import type { ToastOptions } from '@hkdevs/design-system';
import { ApiError } from './client';

/**
 * A failure toast, plus "Reference: <request ID>" when the API failed on its side (a 5xx
 * with a request ID): the ID support finds in the API's logs and Sentry (ADR 0025).
 */
export function withReference(options: ToastOptions, error: unknown): ToastOptions {
  const id = error instanceof ApiError && error.status >= 500 ? error.problem.requestId : undefined;
  if (!id) return options;
  const reference = `Reference: ${id}`;
  const { description } = options;
  if (description !== undefined && typeof description !== 'string') return options;
  return { ...options, description: description ? `${description} ${reference}` : reference };
}
